<template>
  <div>
    <div class="box">
      <div class="columns is-vcentered is-multiline is-centered">
        <div class="column">
          <div class="late-modal-text-titel">{{table_title}}</div>
          <table class="table is-fullwidth table-text-style">
            <thead>
              <tr>
                <th>Position</th>
                <th>Name</th>
                <th>Orders</th>
                <th>Branch</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, i) in data_driver"
                :key="i"
              >
                <th>{{i+1}}</th>
                <td>{{data.name}}</td>
                <td>{{data.countLate}}</td>
                <td>{{data.branch}}</td>
              </tr>
            </tbody>
          </table>
           <div style="font-size: 12px">update at {{dateTimeStamp}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: ['table_title', 'data_driver'],
  data () {
    return {
      dateTimeStamp: dayjs().format('YYYY-MM-DD HH:00:00')
    }
  }
}
</script>

<style scoped>
.late-modal-text-titel{
  padding: 10px;
  font-size: 25px;
}
</style>
